import { useGetSedeQuery } from "../store/services/LookUpService"


export default function SedeLookUp() {
    const {data} = useGetSedeQuery('');
    let optionSede = data?.map((sede: string) => ({value: sede, label: sede}))
    return optionSede;
}